const jaJP = {
  'login.title': 'プレイヤーアカウントログイン',
  'login.description': '実際に学習をする方のログイン画面となります。',
  'login.account_label': 'プレイヤーアカウント',
  'login.password_label': 'パスワード',
  'login.login_button': 'ログイン',
  'home.prologue_button': 'プロローグ',
  'home.epilogue_button': 'エピローグ',
  'password.title': 'ログインが完了しました！',
  'password.input_comment': 'あなたの好きなパスワードを設定してください。',
  'password.input_comment2': '今後はこちらのパスワードでログインします。',
  'password.input_caution1': '※半角英数字８〜１２文字で入力してください',
  'password.input_caution2': '※初期パスワードとは違うパスワードを入力してください',
  'password.input_caution3': '※こちらのパスワードは忘れないように控えておいてください',
  'password.password_label': 'パスワード',
  'password.password_confirm_label': 'パスワード（確認用）',
  'password.register_button': '登録',
  'password.message.password': 'パスワードを入力してください',
  'password.message.password.format': 'パスワードは半角英数字８〜１２文字で入力してください',
  'password.message.password.default': '初期パスワードとは違うパスワードを入れてください',
  'password.message.password_confirm.format': '確認パスワードは同じものを入力してください',
  'profile.title': 'プレイヤー情報',
  'profile.nickname_label': 'ニックネーム',
  'profile.register_button': '登録',
  'profile.cancel_button': 'キャンセル',
  'profile.message.nickname': 'ニックネームを入力してください',
  'profile.message.avatar_file_name': 'アバターを選択してください',
  'saga.login_error_message': 'ログインできませんでした。',
  'saga.player_setting_error_message': 'プレイヤー情報の取得できませんでした。',
  'saga.chapter_list_error_message': 'チャプターリストを取得できませんでした。',
  'saga.put_player_error_message': 'プレイヤー情報の登録できませんでした。',
  'saga.player_logout_message': 'ログアウトしました。',
};
export default jaJP;
